import firebase from 'firebase/app'
import 'firebase/storage'

import logScope from 'log-scope'

const log = logScope('storage')

const storage = {
  isInitialized: false
}
let storageRef

storage.init = (storageUrl) => {
  if (storage.isInitialized === true) {
    log.error('Storage is already initialized')
    return
  }
  storage.isInitialized = true

  storageRef = firebase.app()
    .storage(storageUrl)
    .ref()

  log.success('Storage', storageRef)
}

storage.upload = (file) => new Promise((resolve, reject) => {
  log.debug('Upload to storage')

  const timestamp = +(new Date())
  const filename = `${timestamp}${Math.round(Math.random() * 10000000)}.zip`

  const uploadTask = storageRef.child(filename).put(file)

  uploadTask.on('state_changed',
    snapshot => {
      const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
      log.debug('Progress: ' + progress)
    },
    error => {
      reject(error)
    },
    () => {
      uploadTask.snapshot
        .ref
        .getDownloadURL()
        .then((downloadURL) => {
          resolve({ downloadURL, filename })
        })
        .catch(reject)
    })
})

export default storage
